import React from 'react';
import join from '../assets/join.png';

const JoinSection = ({toSection,section}) => {

    const scrollToForm = () => {
        const formElement = document.getElementById('contact-form');
        if (formElement) {
          formElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      };
  return (
    <div style={{marginTop: '-40px'}} className="relative" id={section}>
      {/* Top wave */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#002147"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      {/* Hero section with background image */}
      <div className="relative min-h-[600px] bg-[#B8E1FF]">
        {/* Background image container */}
        <div 
          className="absolute inset-0 w-full h-full"
          style={{
            backgroundImage: `url(${join})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
        
        {/* Dark overlay */}
        <div 
          className="absolute inset-0 w-full h-full"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.6)'
          }}
        />

        {/* Content overlay */}
        <div className="relative z-10 container mx-auto px-4 py-20">
          <div className="pt-20 mx-auto text-center">
            <h2 className="font-['Grandstander'] text-4xl font-extrabold text-[#fff] mb-6">
              Ready to Lead the Charge?
            </h2>
            
            <h3 className="font-['Grandstander'] text-2xl text-[#fff] mb-8">
              Interested in Joining Us?
            </h3>
            
            <p className="text-[#fff] text-lg mb-8 font-['Lexend']">
              This is your sign to invest in the future and become a Tinker Labs Franchise Owner
            </p>

            <button onClick={scrollToForm} className="bg-[#F18917] text-white px-8 py-3 rounded-full font-['Lexend'] font-semibold hover:bg-[#e60e6b] transition-colors">
              Contact us
            </button>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <path 
            fill="#002147"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default JoinSection;